angular.module('zc.zenclerkS')

  .component('zcsDashboardWidgetNoActiveCampaign', {
    templateUrl: '/templates/zenclerk_s/sites/dashboard/widgets/dashboard-widget-no-active-campaign.html',
    require: {
      dashboard: '^zcsDashboardMain'
    },
    controller: zcsDashboardWidgetNoActiveCampaignController
  });

zcsDashboardWidgetNoActiveCampaignController.$inject = [];
function zcsDashboardWidgetNoActiveCampaignController() {
  const vm = this;

  vm.$onInit = () => {
    vm.project = vm.dashboard.project;
  };
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/dashboard/widgets/dashboard-widget-no-active-campaign.component.js